export const mobileTotalBetCalculate = (gameType, betNumber, belliBets, rowInd, betDiscount, condition, bolBalikRow, bolBalikRowALL, values, betType, device) => {
  if (condition === false) {
    let calAmount;
    if (gameType === "4D3D2D") {
      calAmount = normalCalculation(betNumber, belliBets, rowInd, betDiscount, betType, device, gameType, "normal", values)
    }
    else if (gameType === "3DDEPAN" || gameType === "2DDEPAN" || gameType === "2DTENGAH") {
      calAmount = normalCalculation3D2D(betNumber, gameType, belliBets, rowInd, betDiscount, device, betType, "normal", values)
    }
    else {
      calAmount = normalCalculationAll(betNumber, belliBets, rowInd, betDiscount, gameType, betType)
    }
    return calAmount
  }
  else {
    let totalBetAmountCount = 0;
    let totalDiscountCount = 0;
    let totalDiscount = []
    let totalPayAmount = []

    const isValidBet = (bet) => {
      return bet !== undefined && bet !== "" && !isNaN(parseInt(bet));
    };
    let multiple
    if (betType == "discount") {
      multiple = betDiscount.showMultiple;
    } else if (betType == "fullBet") {
      multiple = betDiscount.showMultipleFullbet
    }

    if (gameType === "4D3D2D") {
      values.map((val, ind) => {
        if (val !== undefined) {
          if (bolBalikRow[ind] !== undefined && val !== undefined) {
            if (device === "Mobile") {
              totalBetAmountCount = 0;
              totalDiscountCount = 0;
            }
            let discountCal
            let discountCal3D
            let discountCal2D
            if (betType == "discount") {
              discountCal = betDiscount.showDisc4d
              discountCal3D = betDiscount.showDisc3d
              discountCal2D = betDiscount.showDisc2d
            }
            else if (betType == "fullBet") {
              discountCal = 0
              discountCal3D = 0
              discountCal2D = 0
            }

            if (val.length === 4) {
              let item4D = val
              let item3D = condition ? val : val.replace(/^\d/, '');
              let item2D = condition ? val : val.replace(/^\d{2}/, '');

              if (isValidBet(belliBets[`4D-${ind}`])) {
                let numberArray = item4D.split('')
                if (device === "Desktop" && gameType === "4D3D2D") {                  
                  let totalBetAmount = generatePermutations(numberArray, multiple, discountCal, belliBets[`4D-${ind}`], device, gameType)
                  
                  totalBetAmountCount += parseFloat(totalBetAmount[0]);
                  if (isValidBet(totalDiscount[ind])) {
                    totalDiscount[ind] = parseFloat(totalDiscount[ind] + totalBetAmount[1])
                    totalPayAmount[ind] = parseFloat(totalPayAmount[ind] + totalBetAmount[0])
                  }
                  else {
                    totalDiscount[ind] = parseFloat(totalBetAmount[1])
                    totalPayAmount[ind] = parseFloat(totalBetAmount[0])
                  }
                }
                else {
                  let totalBetAmount = generatePermutations(numberArray, multiple, discountCal, belliBets[`4D-${ind}`], device, gameType)
                  totalBetAmountCount += parseFloat(totalBetAmount[0])
                  totalDiscountCount += parseFloat(totalBetAmount[1])
                }
              }
              if (isValidBet(belliBets[`3D-${ind}`])) {
                let number3DArray = item3D.split('')
                if (device === "Desktop" && gameType === "4D3D2D") {
                  //let totalBetAmount = generatePermutations(number3DArray, multiple, discountCal3D, belliBets[`3D-${ind}`], device, gameType)
                  let totalBetAmount = generatePermutations(number3DArray, multiple, discountCal3D, belliBets[`3D-${ind}`], device, gameType, "3D")

                  totalBetAmountCount += parseFloat(totalBetAmount[0])
                  if (isValidBet(totalDiscount[ind])) {
                    totalDiscount[ind] = parseFloat(totalDiscount[ind] + totalBetAmount[1])
                    totalPayAmount[ind] = parseFloat(totalPayAmount[ind] + totalBetAmount[0])
                  }
                  else {
                    totalDiscount[ind] = parseFloat(totalBetAmount[1])
                    totalPayAmount[ind] = parseFloat(totalBetAmount[0])
                  }
                }
                else {
                  //let totalBetAmount = generatePermutations(number3DArray, multiple, discountCal3D, belliBets[`3D-${ind}`], device, gameType)
                  let totalBetAmount = generatePermutations(number3DArray, multiple, discountCal3D, belliBets[`3D-${ind}`], device, gameType, "3D")
                  totalBetAmountCount += parseFloat(totalBetAmount[0])
                  totalDiscountCount += parseFloat(totalBetAmount[1])
                }
              }
              if (isValidBet(belliBets[`2D-${ind}`])) {
                let number2DArray = item2D.split('')
                if (device === "Desktop" && gameType === "4D3D2D") {
                  //let totalBetAmount = generatePermutations(number2DArray, multiple, discountCal2D, belliBets[`2D-${ind}`], device, gameType)
                  let totalBetAmount = generatePermutations(number2DArray, multiple, discountCal2D, belliBets[`2D-${ind}`], device, gameType, "2D")
                  totalBetAmountCount += parseFloat(totalBetAmount[0])
                  if (isValidBet(totalDiscount[ind])) {
                    totalDiscount[ind] = parseFloat(totalDiscount[ind] + totalBetAmount[1])
                    totalPayAmount[ind] = parseFloat(totalPayAmount[ind] + totalBetAmount[0])
                  }
                  else {
                    totalDiscount[ind] = parseFloat(totalBetAmount[1])
                    totalPayAmount[ind] = parseFloat(totalBetAmount[0])
                  }
                }
                else {
                  //let totalBetAmount = generatePermutations(number2DArray, multiple, discountCal2D, belliBets[`2D-${ind}`], device, gameType)
                  let totalBetAmount = generatePermutations(number2DArray, multiple, discountCal2D, belliBets[`2D-${ind}`], device, gameType, "2D")
                  totalBetAmountCount += parseFloat(totalBetAmount[0])
                  totalDiscountCount += parseFloat(totalBetAmount[1])
                }
              }
            }

            if (val.length === 3) {
              let item3D = val;
              let item2D = val.replace(/^\d/, '');
              if (isValidBet(belliBets[`3D-${ind}`])) {
                let number3DArray = item3D.split('')
                if (device === "Desktop" && gameType === "4D3D2D") {
                  let totalBetAmount = generatePermutations(number3DArray, multiple, discountCal3D, belliBets[`3D-${ind}`], device, gameType)
                  totalBetAmountCount += totalBetAmount[0]
                  if (isValidBet(totalDiscount[ind])) {
                    totalDiscount[ind] = parseFloat(totalDiscount[ind] + totalBetAmount[1])
                    totalPayAmount[ind] = parseFloat(totalPayAmount[ind] + totalBetAmount[0])
                  }
                  else {
                    totalDiscount[ind] = parseFloat(totalBetAmount[1])
                    totalPayAmount[ind] = parseFloat(totalBetAmount[0])
                  }
                }
                else {
                  let totalBetAmount = generatePermutations(number3DArray, multiple, discountCal3D, belliBets[`3D-${ind}`], device, gameType)
                  totalBetAmountCount += parseFloat(totalBetAmount[0])
                  totalDiscountCount += parseFloat(totalBetAmount[1])
                }
              }
              if (isValidBet(belliBets[`2D-${ind}`])) {
                let number2DArray = item3D.split('')
                if (device === "Desktop" && gameType === "4D3D2D") {
                  let totalBetAmount = generatePermutations(number2DArray, multiple, discountCal2D, belliBets[`2D-${ind}`], device, gameType)
                  totalBetAmountCount += totalBetAmount[0]
                  if (isValidBet(totalDiscount[ind])) {
                    totalDiscount[ind] = parseFloat(totalDiscount[ind] + totalBetAmount[1])
                    totalPayAmount[ind] = parseFloat(totalPayAmount[ind] + totalBetAmount[0])
                  }
                  else {
                    totalDiscount[ind] = parseFloat(totalBetAmount[1])
                    totalPayAmount[ind] = parseFloat(totalBetAmount[0])
                  }
                }
                else {
                  let totalBetAmount = generatePermutations(number2DArray, multiple, discountCal2D, belliBets[`2D-${ind}`], device, gameType)
                  totalBetAmountCount += parseFloat(totalBetAmount[0])
                  totalDiscountCount += parseFloat(totalBetAmount[1])
                }
              }
            }
            if (val.length === 2) {
              let item2D = val;
              if (isValidBet(belliBets[`2D-${ind}`])) {
                let number2DArray = item2D.split('')
                if (device === "Desktop") {
                  let totalBetAmount = generatePermutations(number2DArray, multiple, discountCal2D, belliBets[`2D-${ind}`], device, gameType)
                  totalBetAmountCount += totalBetAmount[0]
                  if (isValidBet(totalDiscount[ind])) {
                    totalDiscount[ind] = (totalDiscount[ind] + totalBetAmount[1])
                    totalPayAmount[ind] = (totalPayAmount[ind] + totalBetAmount[0])
                  }
                  else {
                    totalDiscount[ind] = (totalBetAmount[1])
                    totalPayAmount[ind] = (totalBetAmount[0])
                  }
                }
                else {
                  let totalBetAmount = generatePermutations(number2DArray, multiple, discountCal2D, belliBets[`2D-${ind}`], device, gameType)
                  totalBetAmountCount += (totalBetAmount[0])
                  totalDiscountCount += (totalBetAmount[1])
                }
              }
            }
            if (device === "Mobile") {
              totalPayAmount[ind] = parseFloat(totalBetAmountCount)
              totalDiscount[ind] = parseFloat(totalDiscountCount)
            }
          }
          else {
            let totalBetAmount = normalCalculation(val, belliBets, ind, betDiscount, betType, device, gameType, "normalBolak")
            if (device === "Desktop") {
              totalBetAmountCount += parseFloat(totalBetAmount[0])
              totalDiscount[ind] = parseFloat(totalBetAmount[1])
              totalPayAmount[ind] = parseFloat(totalBetAmount[0])
            }
            else {
              totalPayAmount[ind] = parseFloat(totalBetAmount[0])
              totalDiscount[ind] = parseFloat(totalBetAmount[1])
            }
          }
        }
      })
    }
    else if (gameType === "3DDEPAN" || gameType === "2DDEPAN" || gameType === "2DTENGAH") {
      values.map((val, ind) => {
        if (val !== undefined) {
          let newVal = val.split('').filter(item => item != "X").join('')
          if (bolBalikRow[ind] !== undefined) {
            if (isValidBet(belliBets[ind])) {
              let discountCal = 0;
              if (val.length === 3 || newVal.length === 3) {
                if (betType == "discount") {
                  discountCal = betDiscount.showDisc3d
                }
              }
              else if (val.length === 2 || newVal.length === 2) {
                if (betType == "discount") {
                  discountCal = betDiscount.showDisc2d
                }
              }
              // totalBetAmountCount += generatePermutations(newVal, multiple, discountCal, belliBets[ind])
              let totalBetAmount = generatePermutations(newVal, multiple, discountCal, belliBets[ind], device, gameType)
              if (device === "Desktop") {
                totalBetAmountCount += totalBetAmount[0]
                totalDiscount[ind] = parseFloat(totalBetAmount[1]);
                totalPayAmount[ind] = parseFloat(totalBetAmount[0]);
              }
              else {
                totalPayAmount[ind] = parseFloat(totalBetAmount);
              }
            }
          }
          else {
            if (val !== undefined) {
              let totalBetAmount = normalCalculation3D2D(newVal, gameType, belliBets, ind, betDiscount, device, betType, "normalBolak")
              if (device === "Desktop") {
                totalBetAmountCount += totalBetAmount[0]
                totalDiscount[ind] = parseFloat(totalBetAmount[1]);
                totalPayAmount[ind] = parseFloat(totalBetAmount[0]);
              }
              else {
                totalPayAmount[ind] = parseFloat(totalBetAmount);
              }

            }
          }
        }
      })
    }
    if (device === "Desktop") {
      return [totalBetAmountCount, totalDiscount, totalPayAmount]
    }
    else {
      if (gameType === "4D3D2D") {
        return [totalPayAmount, totalDiscount]
      }
      else {
        return totalPayAmount
      }
    }
  }
};

const normalCalculation = (betNumber, belliBets, index, betDiscount, betType, device, gameType, normalCond, values) => {

  let totalBetAmountCount = 0;

  const isValidBet = (bet) => {
    return bet !== undefined && bet !== "" && !isNaN(parseInt(bet));
  };

  let discountCal
  let discountCal3D
  let discountCal2D
  let rowDiscount = 0;
  let totalDiscount = []
  let totalPayAmount = []
  let multiple

  if (betType == "discount") {
    multiple = betDiscount.showMultiple;
  } else if (betType == "fullBet") {
    multiple = betDiscount.showMultipleFullbet
  }

  if (normalCond === "normal") {
    values.map((val, ind) => {
      if (val !== undefined) {
        rowDiscount = 0;
        totalBetAmountCount = 0;
        if (betType == "discount") {
          discountCal = betDiscount.showDisc4d
          discountCal3D = betDiscount.showDisc3d
          discountCal2D = betDiscount.showDisc2d
        }
        else if (betType == "fullBet") {
          discountCal = 0
          discountCal3D = 0
          discountCal2D = 0
        }

        if (val.length === 4) {
          if (isValidBet(belliBets[`4D-${ind}`])) {
            let diskon = ((belliBets[`4D-${ind}`] * parseInt(multiple) * discountCal) / 100);
            totalBetAmountCount += belliBets[`4D-${ind}`] * parseInt(multiple) - parseFloat(diskon);
            rowDiscount += parseFloat(diskon)
          }
          if (isValidBet(belliBets[`3D-${ind}`])) {
            let diskon = ((belliBets[`3D-${ind}`] * parseInt(multiple) * discountCal3D) / 100);
            totalBetAmountCount += belliBets[`3D-${ind}`] * parseInt(multiple) - parseFloat(diskon);
            rowDiscount += parseFloat(diskon)
          }
          if (isValidBet(belliBets[`2D-${ind}`])) {
            let diskon = ((belliBets[`2D-${ind}`] * parseInt(multiple) * discountCal2D) / 100);
            totalBetAmountCount += belliBets[`2D-${ind}`] * parseInt(multiple) - parseFloat(diskon);
            rowDiscount += parseFloat(diskon)
          }
        }

        if (val.length === 3) {
          if (isValidBet(belliBets[`3D-${ind}`])) {
            let diskon = ((belliBets[`3D-${ind}`] * parseInt(multiple) * discountCal3D) / 100);
            totalBetAmountCount += belliBets[`3D-${ind}`] * parseInt(multiple) - parseFloat(diskon);
            rowDiscount += parseFloat(diskon)
          }
          if (isValidBet(belliBets[`2D-${ind}`])) {
            let diskon = ((belliBets[`2D-${ind}`] * parseInt(multiple) * discountCal2D) / 100);
            totalBetAmountCount += belliBets[`2D-${ind}`] * parseInt(multiple) - parseFloat(diskon);
            rowDiscount += parseFloat(diskon)
          }
        }

        if (val.length === 2) {
          if (isValidBet(belliBets[`2D-${ind}`])) {
            let diskon = ((belliBets[`2D-${ind}`] * parseInt(multiple) * discountCal2D) / 100);
            totalBetAmountCount += belliBets[`2D-${ind}`] * parseInt(multiple) - parseFloat(diskon);
            rowDiscount += parseFloat(diskon)
          }
        }
        
        totalPayAmount[ind] = totalBetAmountCount > 0 ? parseFloat(totalBetAmountCount).toFixed(1) : totalBetAmountCount
        totalDiscount[ind] = rowDiscount > 0 ? rowDiscount.toFixed(1) : rowDiscount
      }
    })
  }
  else {
    rowDiscount = 0;
    totalBetAmountCount = 0;
    if (betType == "discount") {
      discountCal = betDiscount.showDisc4d
      discountCal3D = betDiscount.showDisc3d
      discountCal2D = betDiscount.showDisc2d
    }
    else if (betType == "fullBet") {
      discountCal = 0
      discountCal3D = 0
      discountCal2D = 0
    }

    if (betNumber !== undefined && betNumber.length === 4) {
      if (isValidBet(belliBets[`4D-${index}`])) {
        let diskon = (belliBets[`4D-${index}`] * parseInt(multiple) * parseFloat(discountCal)) / 100;
        totalBetAmountCount += belliBets[`4D-${index}`] * parseInt(multiple) - parseFloat(diskon).toFixed(1);
        rowDiscount += parseFloat(diskon)
      }
      if (isValidBet(belliBets[`3D-${index}`])) {
        let diskon = (belliBets[`3D-${index}`] * parseInt(multiple) * parseFloat(discountCal3D)) / 100;
        totalBetAmountCount += belliBets[`3D-${index}`] * parseInt(multiple) - parseFloat(diskon).toFixed(1);
        rowDiscount += parseFloat(diskon)
      }
      if (isValidBet(belliBets[`2D-${index}`])) {
        let diskon = (belliBets[`2D-${index}`] * parseInt(multiple) * parseFloat(discountCal2D)) / 100;
        totalBetAmountCount += belliBets[`2D-${index}`] * parseInt(multiple) - parseFloat(diskon).toFixed(1);
        rowDiscount += parseFloat(diskon)
      }
    }

    if (betNumber !== undefined && betNumber.length === 3) {
      if (isValidBet(belliBets[`3D-${index}`])) {
        let diskon = (belliBets[`3D-${index}`] * parseInt(multiple) * parseFloat(discountCal3D)) / 100;
        totalBetAmountCount += belliBets[`3D-${index}`] * parseInt(multiple) - parseFloat(diskon).toFixed(1);
        rowDiscount += parseFloat(diskon)
      }
      if (isValidBet(belliBets[`2D-${index}`])) {
        let diskon = (belliBets[`2D-${index}`] * parseInt(multiple) * parseFloat(discountCal2D)) / 100;
        totalBetAmountCount += belliBets[`2D-${index}`] * parseInt(multiple) - parseFloat(diskon).toFixed(1);
        rowDiscount += parseFloat(diskon)
      }
    }

    if (betNumber !== undefined && betNumber.length === 2) {
      if (isValidBet(belliBets[`2D-${index}`])) {
        let diskon = (belliBets[`2D-${index}`] * parseInt(multiple) * parseFloat(discountCal2D)) / 100;
        totalBetAmountCount += belliBets[`2D-${index}`] * parseInt(multiple) - parseFloat(diskon).toFixed(1);
        rowDiscount += parseFloat(diskon)
      }
    }
  }

  if (device === "Desktop") {
    if (normalCond === "normal") {
      return [totalBetAmountCount, totalPayAmount, totalDiscount];
    }
    else {
      return [totalBetAmountCount, rowDiscount];
    }
  }
  else {
    if (normalCond === "normal") {
      return [totalPayAmount, totalDiscount]
    }
    else {
      return [totalBetAmountCount, rowDiscount];
    }
  }
}

const normalCalculation3D2D = (betNumber, gameType, belliBets, rowInd, betDiscount, device, betType, normalCond, values) => {
  let totalBetAmountCount = 0;
  const isValidBet = (bet) => {
    return bet !== undefined && bet !== "" && !isNaN(parseInt(bet));
  };


  let discountCal = 0;
  let rowDiscount = 0;
  let totalDiscount = []
  let totalPayAmount = []
  let multiple

  if (betType == "discount") {
    multiple = betDiscount.showMultiple;
  } else if (betType == "fullBet") {
    multiple = betDiscount.showMultipleFullbet
  }

  if (normalCond === "normal") {
    values.map((val, ind) => {
      if (val !== undefined) {       
        let newBetNumber = val.split('').filter(item => item != "X").join('')
        if (val.length === 3 || newBetNumber.length === 3 && gameType === "3DDEPAN") {
          if (betType == "discount") {
            discountCal = betDiscount.showDisc3d
          }
        }
        else if (val.length === 2 || newBetNumber.length === 2 && gameType === "2DDEPAN" || gameType === "2DTENGAH") {
          if (betType == "discount") {
            discountCal = betDiscount.showDisc2d
          }
        }
        else {
          discountCal = 0
        }
        
        if (isValidBet(belliBets[ind])) {
          let diskon = (belliBets[ind] * parseInt(multiple) * parseFloat(discountCal)) / 100;
          let totalBetAmount = belliBets[ind] * parseInt(multiple) - diskon;
          if (device === "Desktop") {
            totalBetAmountCount += totalBetAmount
          }
          else {
            totalPayAmount[ind] = parseFloat(totalBetAmount).toFixed(1)
          }
          totalPayAmount[ind] = parseFloat(totalBetAmount).toFixed(1)
          totalDiscount[ind] = parseFloat(diskon).toFixed(1);
          rowDiscount += parseFloat(diskon);
        }
      }
    })
  }
  else {
    if (betNumber !== undefined) {
      let newBetNumber = betNumber.split('').filter(item => item != "X").join('')
      if (betNumber.length === 3 || newBetNumber.length === 3) {
        if (betType == "discount") {
          discountCal = betDiscount.showDisc3d
        }
      }
      else if (betNumber.length === 2 || newBetNumber.length === 2) {
        if (betType == "discount") {
          discountCal = betDiscount.showDisc2d
        }
      }
      else {
        //
      }
      if (isValidBet(belliBets[rowInd])) {
        let diskon = (belliBets[rowInd] * multiple * discountCal) / 100;
        let totalBetAmount = belliBets[rowInd] * multiple - parseFloat(diskon);
        if (device === "Desktop") {
          totalBetAmountCount += totalBetAmount
        }
        else {
          totalBetAmountCount = totalBetAmount
        }
        rowDiscount += parseFloat(diskon).toFixed(1)
      }
    }
  }

  if (device === "Desktop") {
    if (normalCond === "normal") {
      return [totalBetAmountCount, totalPayAmount, totalDiscount];
    }
    else {
      return [totalBetAmountCount, rowDiscount];
    }
  }
  else {
    if (normalCond === "normal") {
      return totalPayAmount;
    }
    else {
      return totalBetAmountCount
    }
  }
}

const normalCalculationAll = (betNumber, belliBets, rowInd, betDiscount, gameType, betType) => {
  let totalBetAmountCount = 0;
  let keiDisValue = ''
  let keiKey = ''
  let keiValue = ''
  let multiple
  
  if (betType == "discount") {
    multiple = betDiscount.showMultiple;
  } else if (betType == "fullBet") {
    multiple = betDiscount.showMultipleFullbet
  } else {
    multiple = betDiscount.showMultiple;
  }
  
  if (gameType === "5050") {
    keiKey = "kei_" + betNumber
    if (keiKey !== '') {
      keiDisValue = betDiscount[keiKey]
    }
    keiValue = (belliBets * multiple) - (belliBets * multiple * (keiDisValue / 100))
    totalBetAmountCount = keiValue - (keiValue * betDiscount.showDisc) / 100
  }
  return totalBetAmountCount
}

/*const generatePermutations = (input, mulple, discountCal, beliAmount, device, gameType) => {
  let doublicate = 1;
  const uniqueArray = [...new Set(input)];
  if (input.length === uniqueArray.length) {
    doublicate = 1
  }
  else {
    if (input.length === 4 && uniqueArray.length === 1) {
      doublicate = 24
    }
    else if (input.length === 4 && uniqueArray.length === 2) {
      doublicate = 4
    }
    else if (input.length === 3 && uniqueArray.length === 1) {
      doublicate = 6
    }
    else {
      doublicate = 2
    }

  }

  let count = 1;
  for (let i = 1; i <= input.length; i++) {    
    count = count * i
  }
  count = count / doublicate
 
  let discount = count * beliAmount * mulple * discountCal / 100
  
  let calculateAmount = count * beliAmount * mulple - discount;

  if (device === "Desktop" || gameType === "4D3D2D") {
    return [calculateAmount, discount]
  }
  else {
    return calculateAmount
  }
}*/

const generatePermutations = (input, mulple, discountCal, beliAmount, device, gameType, betLevel = "4D") => {

  // helper function for permutations
  const perms = (arr) => {
    if (arr.length <= 1) return [arr];
    const res = [];
    for (let i = 0; i < arr.length; i++) {
      const rest = [...arr.slice(0, i), ...arr.slice(i + 1)];
      perms(rest).forEach(p => res.push([arr[i], ...p]));
    }
    return res;
  }

  let count;

  // -------- 3D from 4D ----------
  if (betLevel === "3D" && input.length === 4) {
    const combos = new Set();

    for (let i = 0; i < 4; i++) {
      let temp = input.slice(0, i).concat(input.slice(i + 1));
      perms(temp).forEach(p => combos.add(p.join("")));
    }

    count = combos.size;
  }

  // -------- 2D from 4D ----------
  else if (betLevel === "2D" && input.length === 4) {
    const combos = new Set();

    for (let i = 0; i < 4; i++) {
      for (let j = i + 1; j < 4; j++) {
        const temp = [input[i], input[j]];
        perms(temp).forEach(p => combos.add(p.join("")));
      }
    }

    count = combos.size;
  }

  // -------- 4D normal ----------
  else {
    let doublicate = 1;
    const uniqueArray = [...new Set(input)];

    if (input.length === uniqueArray.length) {
      doublicate = 1;
    } else {
      if (input.length === 4 && uniqueArray.length === 1) {
        doublicate = 24;
      } else if (input.length === 4 && uniqueArray.length === 2) {
        doublicate = 4;
      } else if (input.length === 3 && uniqueArray.length === 1) {
        doublicate = 6;
      } else {
        doublicate = 2;
      }
    }

    count = 1;
    for (let i = 1; i <= input.length; i++) {
      count = count * i;
    }
    count = count / doublicate;
  }

  let discount = count * beliAmount * mulple * discountCal / 100;
  let calculateAmount = count * beliAmount * mulple - discount;

  if (device === "Desktop" || gameType === "4D3D2D") {
    return [calculateAmount, discount];
  } else {
    return calculateAmount;
  }
};

